export default function getResource(label, vars = []) {
    const resources = {
        dontMissOut: `Faites vite! Adhérez à Beauty Insider, notre programme de fidélisation GRATUIT, pour accumuler *${vars[0]} points* avec cette commande.`,
        dontMissOutSignIn: `Faites vite! Ouvrez une session dans votre compte Beauty Insider pour accumuler *${vars[0]} points* avec cette commande.`,
        signIn: 'Ouvrir une session',
        createAccount: 'Créer un compte'
    };

    return resources[label];
}
